import { Injectable, Inject, OnDestroy } from '@angular/core';
import { Observable, of, combineLatest, forkJoin, Subject, Subscription, OperatorFunction } from 'rxjs';
// tslint:disable-next-line: max-line-length
import {
    DwMdFormActionHandler, DwMdFormActionState, DwMdFormActionResult, DwFormAction, DwSecuritySSOService, DwSecurityRepositoryServiceToken,
    DwSecurityRepositoryService, DwSecurityUserService, DwMdFormContextInfo, DwOrmDataService, DwOrmDataServiceToken, DwMdFormInitActionHandler,
    DwMdFormInitActionState, DwAction, DwActionType, DwFormActionConfigDefaultComponent, DwMetaDataServiceToken,
    DwMetaDataService, DwMetaDataFormApi, DwEventService, DwConfirmDialogConfig, DwModalService, deepCopy, DwQuery, DwItem,
    DwMessagingService, DwFormContextMode, DwContext, DwMetaDataFormStateService, DwInMemoryDataSource, DwOrmData, DwQueryHelper
} from '@devwareapps/devware-cap';
import { map, mergeMap, concatAll, switchMap, concatMap, tap, delay } from 'rxjs/operators';
import { WachterUserExt } from '../../../shared/models/wachter-user.model';
import {
    ProjectKickoffMetaDataItemNames, ProjectsKickoffEntity, ProjectKickoffMetaData,
    ProjectKickoffActiveUnusedJobNumberQueryEntity, TeamAssignmentEntity
}
    from 'src/app/customizations/project-kickoff/meta-data/projectkickoff-meta-data.service';
import { EnhancedUtilsService } from 'src/app/customizations/utils/services/enhanced-utils.service';
import * as moment_ from 'moment';
import { debounceTime, first } from 'rxjs/operators';
import { EthosCustomerEntity, AppMetaDataService, EthosWachterDepartmentEntity, 
          } from 'src/app/meta-data/app-meta-data.service';
import { ProjectMilestoneEntity, EscalationEntity, ReportingEntity, StakeholderEntity, KickoffChecklistEntity,
         BillingEntity, BillingDepartmentEntity } from 'src/app/customizations/project-kickoff/meta-data/projectkickoff-meta-data.service'
import { ProjectKickoffAddNewJobNumberActionService, AddJnResult, ProjectKickoffVariableContext } from 'src/app/customizations/project-kickoff/actions/project-kickoff-add-new-jobnumber.service';
const moment = moment_;

@DwAction({
    isGlobal: false,
    actionType: DwActionType.formAction,
    configComponent: DwFormActionConfigDefaultComponent,
    display: 'Project Kickoff - Save',
    keyName: 'projectsKickoffSave',
    actionMessage: '',
    parentItemName: ProjectKickoffMetaDataItemNames.ProjectsKickoff,
    defaultButtonConfig: {
        buttonText: 'Save and Continue',
        buttonTitle: 'Save Kickoff Document Progress',
        command: 'saveKickoffDocument',
        iconClass: 'fa fa-save',
        buttonClass: 'btn btn-success'
    }
})
@Injectable({
    providedIn: 'root'
})
export class ProjectKickoffSaveService
    implements DwMdFormActionHandler, DwMdFormInitActionHandler, OnDestroy {

    documents: KickOffJn[] = [];

    formActionState: DwMdFormActionState;
    context: DwContext;
    subscriptions: Subscription[] = [];
    item = ProjectKickoffMetaDataItemNames.ProjectsKickoff;
    addMode: boolean = false;
    editMode: boolean = false;
    args: ProjectKickoffVariableContext;

    private currentDateTime: string = moment().utc().format("MM/DD/YYYY hh:mm A");
    private currentUserId: number = new WachterUserExt(this.dwSecurityUserService.securityContext.ApplicationUser).trustUserId;
    formApi: DwMetaDataFormApi

    constructor(
        private dwModalService: DwModalService,
        private dwEventService: DwEventService,
        private utils: EnhancedUtilsService,
        private dwSecurityUserService: DwSecurityUserService,
        protected msalHandler: DwSecuritySSOService,
        protected addJnSvc: ProjectKickoffAddNewJobNumberActionService,
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        @Inject(DwSecurityRepositoryServiceToken) protected securityRepository: DwSecurityRepositoryService,
        @Inject(DwOrmDataServiceToken) protected dataService: DwOrmDataService,
        protected messageService: DwMessagingService
    ) { 
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    customerId: number;
    static fixingBillingDepartments: boolean = false;
    initAction(formInitActionState: DwMdFormInitActionState) {
        this.formApi = formInitActionState.formApi;
        this.context = formInitActionState.context;
        this.editMode = this.formApi.getFormConfig().formMode == DwFormContextMode.edit;
        this.addMode = this.formApi.getFormConfig().formMode == DwFormContextMode.add;
        this.formApi.getFormDataChanges(100).subscribe(p => {
            const doc: ProjectsKickoffEntity = p;
            this.assignHybrid(doc);
        });
    }

    assignHybrid(doc : ProjectsKickoffEntity){
        const setKeys = (...sets: any[]) => { sets.forEach(i => i?.forEach(j => j.HybridKey = j.HybridKey ?? this.uuid())); }
        setKeys(doc.ProjectMilestone, doc.Escalation, doc.Stakeholder, doc.Reporting, doc.Billing, doc.TeamAssignment, doc.KickoffChecklist);
        doc.Billing.forEach(b => setKeys(b.BillingDepartment));
    }
    save(orig: ProjectsKickoffEntity, jn: number, editMode: boolean, saveMode: boolean, cloneMode: boolean): Observable<KickOffJn> {
        const doc: ProjectsKickoffEntity = deepCopy(orig);
        this.assignHybrid(doc);
        doc.JobNumberId = jn;
    
        if (editMode) {
            this.args = this.formApi.getVariableContextValue<ProjectKickoffVariableContext>()
            const targets = this.args.KickoffIds.split(',')
                .map(i => { return { kid: parseFloat(i.split(':')[0]), job: parseFloat(i.split(':')[1]) }; });
            const target = targets.find(i => i.job == jn);
            doc.KickoffId = target.kid;
            doc.JobNumberId = target.job;
        }

        if (cloneMode)
            doc.KickoffId = null;
        doc.ParentProjectsKickoff = [];
        if (editMode){
            const save = (data : any[]) => {
                this.fix<TeamAssignmentEntity>(doc, 'TeamAssignmentId', doc.TeamAssignment, data, 1);
                this.fix<BillingEntity>(doc, 'BillingId', doc.Billing, data, 2, (u, c) => {
                    u?.BillingDepartment?.forEach(bd => {
                        const curDept = c?.BillingDepartment.find(i => i.HybridKey == bd.HybridKey);
                        if (curDept != undefined) 
                            bd.BillingDeptId = curDept.BillingDeptId;
                        bd.BillingId = c?.BillingId; 
                    })
                });
                this.fix<ProjectMilestoneEntity>(doc, 'ProjectMilestoneId', doc.ProjectMilestone, data, 3);
                this.fix<EscalationEntity>(doc, 'EscalationId', doc.Escalation, data, 4);
                this.fix<StakeholderEntity>(doc,  'StakeholderId', doc.Stakeholder,data, 5);
                this.fix<ReportingEntity>(doc, 'ReportingId', doc.Reporting, data, 6);
                this.fix<KickoffChecklistEntity>(doc, 'KickoffChecklistId', doc.KickoffChecklist, data, 7);

                const results = this.dataService.saveEntity(doc, true);
                results.subscribe(i => { });
                return results;
            };
            const getTeams = this.getData(doc.KickoffId, new AppMetaDataService().TeamAssignment);

            const fetch = (q, md) => q.AddPrefetchPath(md.Billing.Relations.BillingDepartment).OrderBy(md.BillingDepartment.WachterDepartmentId)
            const getBillings = this.getData(doc.KickoffId, new AppMetaDataService().Billing, fetch);

            const getMil = this.getData(doc.KickoffId, new AppMetaDataService().ProjectMilestone);
            const getEsc = this.getData(doc.KickoffId, new AppMetaDataService().Escalation);
            const getStk = this.getData(doc.KickoffId, new AppMetaDataService().Stakeholder);
            const getRpt = this.getData(doc.KickoffId, new AppMetaDataService().Reporting);
            const getChk = this.getData(doc.KickoffId, new AppMetaDataService().KickoffChecklist);

            return this.utils
                       .chain<ProjectsKickoffEntity>(getTeams, getBillings, getMil, getEsc, getStk, getRpt, getChk,
                                                     save)([doc.KickoffId])
                       .pipe(map(i => { 
                            return { Kickoff: i, JobNumber: i.JobNumberId };
                        }));
        }
        else
            return this.dataService.saveEntity(doc, true).pipe(map(i => { 
                return { Kickoff: i, JobNumber: i.JobNumberId };
            }));
    }
    getData(kickoffId: number, item: DwItem, adjust: (q : DwQuery<DwOrmData>, md: AppMetaDataService) => void = (q,m) => {}) 
        : (data:any[]) => Observable<DwOrmData[]> {
        const md = new AppMetaDataService();
        const qh = new DwQueryHelper();
        var query = item.CreateQuery().AddFilterAnd(qh.filters.Equal((item as any).KickoffId, kickoffId))
        adjust(query, md);
        return (id) => this.dataService.executeQuery(query);
    }
    fix<T extends DwOrmData>(doc : ProjectsKickoffEntity, pk : string, inMem: T[], data: any[], idx: number,
                             adjust : (u : T, c : T) => void = (u, c) => {}){
        const existing : T[] = data.length > idx ? data[idx] : []
        this.sync<T>(doc.KickoffId, pk, inMem, existing, adjust);
    }
    sync<T extends DwOrmData>(kickoffId: number, id: string, inMemory : T[], db: T[],
                              adjust : (u : T, c: T) => void = (u, c) => {}){
        inMemory?.forEach(t => { /* Updates */
            const current = db.find(i => (i as any).HybridKey == (t as any).HybridKey);
            if (current != undefined) t[id] = current[id];
            t['KickoffId'] = kickoffId; 
            adjust(t, current);
        })
    }

    handleAction(formActionState: DwMdFormActionState): Observable<DwMdFormActionResult> {
        this.formActionState = formActionState;
        this.context = formActionState.context;
        this.args = this.formApi.getVariableContextValue<ProjectKickoffVariableContext>()

        const doc: ProjectsKickoffEntity = this.formApi.getFormData();
        const jn: number[] = (this.args.KickoffIds != undefined && this.args.KickoffIds.length > 0)
            ? this.args.KickoffIds.split(',').map(i => parseFloat(i.split(':')[1]))
            : doc.ParentProjectsKickoff.map(k => k.JobNumberId);
        if (jn.length == 0) return;

        const firstSave: boolean = this.addMode && this.args.KickoffIds == undefined;
        const confirmDialogConfig: DwConfirmDialogConfig = {
            message: "After saving, assigned Job Numbers will be locked & cannot be changed. <br><br>Are you sure you are ready to save?",
            title: 'Lock Assigned Job Numbers & Save Kickoff Document Progress?',
            showConfirmDialog: true,
        };

        const editMode: boolean = this.args.KickoffIds?.length > 0 || this.editMode;
        const saveMode: boolean = !editMode;
        if (firstSave)
            return this.dwModalService.showConfirmDialog(confirmDialogConfig)
                .pipe(map(result => {
                    if (result)
                        this.invokeSave(jn, doc, editMode, saveMode);
                    return { success: result };
                }));

        this.invokeSave(jn, doc, editMode, saveMode);
        return of({ success: true });
    }
    invokeSave(jn: number[], doc: ProjectsKickoffEntity, editMode: boolean, saveMode: boolean) {
        const jns = jn.map<Observable<KickOffJn>>(i => {

            const cloneMode: boolean = i > 0 && i != doc.JobNumberId && doc.JobNumberId > 0;
            return this.save(doc, i, editMode, saveMode, cloneMode);
        });
        this.documents = [];
        forkJoin(jns).subscribe(results => {
            this.documents = results;
            this.args.KickoffIds = results.filter(i => i.Kickoff.KickoffId > 0)
                                          .map(i => `${i.Kickoff.KickoffId}:${i.JobNumber}`).toString()
            this.formApi.patchVariableContext(this.args);
            if (results.length > 0){
                const doc = results[0].Kickoff;
                const ms = doc.ProjectMilestone;
                const es = doc.Escalation;
                const sh = doc.Stakeholder;
                const rp = doc.Reporting;
                const tm = doc.TeamAssignment;
                const cl = doc.KickoffChecklist;
                this.formApi.patchFormData({ProjectMilestone: ms, 
                                            Escalation: es, 
                                            Stakeholder: sh, 
                                            Reporting: rp,
                                            TeamAssignment: tm,
                                            KickoffChecklist: cl
                                           });
            }
        });
    }
    uuid(): string { return `${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 8)}`; }
}
export interface KickOffJn {
    Kickoff: ProjectsKickoffEntity,
    JobNumber: number
}
